import type {ReactElement} from 'react';
import {ClickableDiv} from '@Components/clickable-div';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import {Text, TextSize} from '@Components/text';
import type {PromoCodePillProps} from '@Components/checkout-flow/components/promo-code-pill/promo-code-pill.types';
import styles from './promo-code-pill.module.scss';

export function PromoCodePill({isVisible, onClick}: PromoCodePillProps): ReactElement {
  return (
    <ClickableDiv onClick={onClick} className={`${styles.pill} ${isVisible ? '' : styles.hidden}`} aria-hidden={!isVisible}>
      <Icon icon="icon-discount" size={IconSize.SIZE_ICON_16} className={`content-body-white ${styles.icon}`} ariaHidden />
      <Text val={window.i18next.t('pmwjs_have_a_promo_code')} size={TextSize.MD} bold className="content-body-white" />
    </ClickableDiv>
  );
}
